import React from 'react';
import { IoIosHelp } from 'react-icons/io';
import { Button, IconButton, Tooltip, Text } from '@chakra-ui/react';

interface TourIcon {
  onClick: () => void;
}

const TourIcon: React.FC<TourIcon> = ({ onClick }) => {
  return (
    <Tooltip
      label={
        <Text textColor="text.100">
          Clique para iniciar o <strong>tutorial guiado</strong> da Central de
          Ajuda do Portal do Cliente.
        </Text>
      }
      placement="left"
      hasArrow
      bg="grey.300"
    >
      <IconButton
        as={Button}
        aria-label="tutorial guiado"
        zIndex={5}
        right="40px"
        bottom="20px"
        position="fixed"
        onClick={onClick}
        borderRadius="80px"
        icon={<IoIosHelp size="40px" />}
      />
    </Tooltip>
  );
};

export default TourIcon;
